import { compareTariffPlan } from "@/api/compareTariffPlan";
import { timeAndLoadTypes } from "@/api/femsAPI";
import { CalendarDate } from "@/components/Calendar";
import { useQuery } from "@tanstack/react-query";
import { ProcessQueryEnabeld } from "./useProcessedQuery";

type PlanName = "산업용(을)고압A선택3" | "산업용(을)고압A선택2" | "산업용(을)고압A선택1";

export const useMonthlyQuery = (
  {
    monthlyTrioEnabled,
    monthlyTrioLoadTypeEnabled,
    monthlySingleEnabled,
    monthlyEnabled,
    previousMonthlyEnabled,
    monthlyPairEnabled,
    monthlyEquipmentEnabled,
    monthlyBillingEnabled,
    compareTariffEnabled,
    compareTotalEnabled,
    compareMaxPowerEnabled,
  }: ProcessQueryEnabeld,
  selectedDate?: CalendarDate,
  equipment?: string | null,
  planName?: string | null,
) => {
  const today = (selectedDate && selectedDate[0]) ?? new Date();
  // const year = today.getUTCFullYear();
  // const month = today.getUTCMonth() + 1; // getUTCMonth()는 0부터 시작하므로 1을 더합니다.
  // const day = today.getUTCDate();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const start = `${year}-${String(month).padStart(2, "0")}-${String(day - 1).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;
  const end = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;

  const { data: monthlyTrio, isLoading: monthlyTrioLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "MONTHLY_TRIO",
      date: `${year}-${month}-${day}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: monthlyTrioEnabled,
  });

  const { data: monthlySingle, isLoading: monthlySingleLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "MONTHLY_SINGLE",
      date: `${year}-${month}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: monthlySingleEnabled,
  });

  const { data: monthlyPair, isLoading: monthlyPairLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "MONTHLY_PAIR",
      date: `${year}-${month}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: monthlyPairEnabled,
  });

  const { data: monthlyTrioLoadType, isLoading: monthlyTrioLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getPeriodLoadType({
      start: `${year}-${month}-01T00:00:00.000Z` || start,
      end: `${year}-${month}-${day}T23:59:59.999Z` || end,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: monthlyTrioLoadTypeEnabled,
  });

  const { data: monthly, isLoading: monthlyLoading } = useQuery({
    ...timeAndLoadTypes.getTimeMonthly({
      year: year,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: monthlyEnabled,
  });

  const { data: previousMonthly, isLoading: previousMonthlyLoading } = useQuery({
    ...timeAndLoadTypes.getTimeMonthly({
      year: year - 1,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: previousMonthlyEnabled,
  });

  // 기계 타입별
  const { data: monthlyEquipment, isLoading: monthlyEquipmentLoading } = useQuery({
    ...timeAndLoadTypes.getEquipment({
      year: year,
      month: month,
      ...(equipment ? { equipmentType: equipment } : {}),
    }),
    enabled: monthlyEquipmentEnabled,
  });

  // 월별 청구 요금
  const { data: monthlyBilling, isLoading: monthlyBillingLoading } = useQuery({
    ...timeAndLoadTypes.getMonthlyBilling({
      year: year,
    }),
    enabled: monthlyBillingEnabled,
  });

  // 요금제 비교
  const { data: compareData, isLoading: compareLoading } = useQuery({
    ...compareTariffPlan.get({
      year: year,
      month: month,
      targetPlan: planName as PlanName,
    }),
    enabled: compareTariffEnabled,
  });

  // 요금제 비교 - 전력량가변
  const { data: compareTotalEnergy, isLoading: compareTotalEnergyLoading } = useQuery({
    ...compareTariffPlan.totalEnergy({
      year: year,
      month: month,
      targetPlan: planName as PlanName,
    }),
    enabled: compareTotalEnabled,
  });

  // 요금제 비교 - 최대전력가변
  const { data: compareMaxPower, isLoading: compareMaxPowerLoading } = useQuery({
    ...compareTariffPlan.maxPower({
      year: year,
      month: month,
      targetPlan: planName as PlanName,
    }),
    enabled: compareMaxPowerEnabled,
  });

  return {
    monthlyTrio,
    monthlyTrioLoadType,
    monthlySingle,
    monthly,
    previousMonthly,
    monthlyPair,
    monthlyEquipment,
    monthlyBilling,
    compareData,
    compareTotalEnergy,
    compareMaxPower,

    monthlyTrioLoading,
    monthlyTrioLoadTypeLoading,
    monthlySingleLoading,
    monthlyLoading,
    previousMonthlyLoading,
    monthlyPairLoading,
    monthlyEquipmentLoading,
    monthlyBillingLoading,
    compareLoading,
    compareTotalEnergyLoading,
    compareMaxPowerLoading,
  };
};
